<template>
  <TitleWrapper
    :title="pluralToSingular(className)"
    additional-name="Settings"
    :is-buttons-hidden="true"
    :is-right-bar-button-hidden="true"
  />
  <UITabs v-model="activePage" :tabs-list="tabsList" />
  <div v-if="activePage === FEATURES_TABS.GENERAL">
    <ClassCustomName />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.PERMISSION">
    <ClassPermission />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.NOTIFICATION">
    <ClassNotification />
  </div>
</template>

<script>
import ClassNotification from '@src/router/views/settings/notifications/class/ClassNotification.vue'
import { FEATURES_TABS_LIST, FEATURES_TABS } from '@src/constants/general-constants.js'
import ClassPermission from '@src/router/views/settings/system-settings/ClassPermission.vue'
import UITabs from '@src/components/UiElements/UITabs.vue'
import ClassCustomName from '@src/router/views/settings/system-settings/ClassCustomName.vue'
import { mapState } from 'vuex'
import TitleWrapper from '@components/TitleWrapper.vue'
import { pluralToSingular } from '@/src/utils/generalUtil'

export default {
  name: 'Settings',
  components: {
    UITabs,
    ClassCustomName,
    ClassNotification,
    ClassPermission,
    TitleWrapper,
  },

  page: {
    title: 'Features Settings',
  },
  data() {
    return {
      FEATURES_TABS,
      tabsList: FEATURES_TABS_LIST,
      activePage: FEATURES_TABS.GENERAL,
    }
  },
  computed: {
    ...mapState({
      className: (state) => state.featureNaming.routerList.CLASSES.DISPLAY_NAME,
    }),
  },
  methods: {
    pluralToSingular,
  },
}
</script>
